const filters = {
  namespaced: true,
  state: {
    DateFrom: '',
    Nationality: '',
    DateTill: '',
    Gender: '',
    Age: '',
    Channel: '',
    Wraistline: '',
    IsKidneyPossibility: false,
    IsCardiovascularPossibility: false,
    IsDiabetesPossibility: false,
    IsDiabeticRetinaPossibility: false,
    KidneyPossibility: 'all',
    CardiovascularPossibility: 'all',
    DiabetesPossibility: 'all',
    DiabeticRetinaPossibility: 'all'
  },
  getters: {
    getAllFilter: state => {
      return state
    }
  },
  mutations: {
    setDateFrom: (state, data) => {
      state.DateFrom = data
    },
    setNationality: (state, data) => {
      state.Nationality = data
    },
    setDateTill: (state, data) => {
      state.DateTill = data
    },
    setGender: (state, data) => {
      state.Gender = data
    },
    setAge: (state, data) => {
      state.Age = data
    },
    setChannel: (state, data) => {
      state.Channel = data
    },
    setWraistline: (state, data) => {
      state.Wraistline = data
    },
    setIsKidneyPossibility: (state, data) => {
      state.IsKidneyPossibility = data
    },
    setIsCardiovascularPossibility: (state, data) => {
      state.IsCardiovascularPossibility = data
    },
    setIsDiabetesPossibility: (state, data) => {
      state.IsDiabetesPossibility = data
    },
    setIsDiabeticRetinaPossibility: (state, data) => {
      state.IsDiabeticRetinaPossibility = data
    },
    setKidneyPossibility: (state, data) => {
      state.KidneyPossibility = data
    },
    setCardiovascularPossibility: (state, data) => {
      state.CardiovascularPossibility = data
    },
    setDiabetesPossibility: (state, data) => {
      state.DiabetesPossibility = data
    },
    setDiabeticRetinaPossibility: (state, data) => {
      state.DiabeticRetinaPossibility = data
    }
  },
  actions: {
    applyFilter: ({ commit }, datas) => {
      commit('setDateFrom', datas.DateFrom)
      commit('setNationality', datas.Nationality)
      commit('setDateTill', datas.DateTill)
      commit('setGender', datas.Gender)
      commit('setAge', datas.Age)
      commit('setChannel', datas.Channel)
      commit('setWraistline', datas.Wraistline)
      commit('setIsKidneyPossibility', datas.IsKidneyPossibility)
      commit('setIsCardiovascularPossibility', datas.IsCardiovascularPossibility)
      commit('setIsDiabetesPossibility', datas.IsDiabetesPossibility)
      commit('setIsDiabeticRetinaPossibility', datas.IsDiabeticRetinaPossibility)
      commit('setKidneyPossibility', datas.KidneyPossibility)
      commit('setCardiovascularPossibility', datas.CardiovascularPossibility)
      commit('setDiabetesPossibility', datas.DiabetesPossibility)
      commit('setDiabeticRetinaPossibility', datas.DiabeticRetinaPossibility)
    },
    resetFilter: ({ commit }) => {
      commit('setDateFrom', '')
      commit('setNationality', '')
      commit('setDateTill', '')
      commit('setGender', '')
      commit('setAge', '')
      commit('setChannel', '')
      commit('setWraistline', '')
      commit('setIsKidneyPossibility', false)
      commit('setIsCardiovascularPossibility', false)
      commit('setIsDiabetesPossibility', false)
      commit('setIsDiabeticRetinaPossibility', false)
      commit('setKidneyPossibility', 'all')
      commit('setCardiovascularPossibility', 'all')
      commit('setDiabetesPossibility', 'all')
      commit('setDiabeticRetinaPossibility', 'all')
    }
  }
}
export default filters
